import { ComponentType } from 'react'
import { TbFileText, TbLink } from 'react-icons/tb'
import { Text } from 'ui-kit/typography'
import { IntegrationType } from 'routes/Integrations/helpers/types'
import { Link } from 'ui-kit/actions/link/Link'
import classes from './IntegrationPageLinks.module.scss'

type LinkRecord = {
  label: string
  href: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Icon: ComponentType<any>
}

export function IntegrationPageLinks({
  integration,
}: {
  integration: IntegrationType
}) {
  const links: LinkRecord[] = []

  if (integration?.appUri) {
    links.push({
      label: 'Application URL',
      href: integration.appUri,
      Icon: TbLink,
    })
  }

  if (integration?.apiDocsUri) {
    links.push({
      label: 'API Documentation',
      href: integration.apiDocsUri,
      Icon: TbFileText,
    })
  }

  if (!links.length) {
    return null
  }

  return (
    <section className={classes.section}>
      <ul className={classes.links}>
        {links.map(({ label, href, Icon }) => (
          <li className={classes.link} key={label}>
            <div className={classes.link__caption}>
              <Icon />
              <Text as={'span'} className={classes.link__text}>
                {label}:
              </Text>
            </div>
            <Link
              type='noLineGradient'
              href={href}
              target='_blank'
              className={classes.link__url}
            >
              {href}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
